module.exports = __webpack_public_path__ + "img/re_lod_photo2.8973d6d1.png";